import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCManageEmpowermentTrainingsConducted = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Empowerment trainings conducted" />
    </Box>
  );
};
